import * as React from 'react';
import { Component, ComponentPropsWithoutRef } from 'react';

import { IFlowEventData } from 'types/analytics';
import AnalyticsService from 'modules/analytics-provider/analytics-provider.service';
import { SUPPORT_LINKS_ANALYTICS_ACTIONS } from './support-link-event-tracker.constants';
import { CATEGORY } from 'modules/analytics-provider/analytics-provider.constants';

/**
 * Track click events for links which are provided through translations
 */
export class SupportLinkEventTracker extends Component<ComponentPropsWithoutRef<'div'> &
Pick<IFlowEventData, 'flowStepDetails' | 'flowSubType'>> {
    public readonly SUPPORT_LINK_SELECTOR: string = 'a[data-role="support-link"]';
    public readonly FAQ_LINK_SELECTOR: string = 'a[data-role="faq-link"]';

    public supportLinkElement: HTMLAnchorElement | null;
    public faqLinkElement: HTMLAnchorElement | null;

    public addEventListener = (ref: HTMLDivElement): void => {
        if (!ref || this.supportLinkElement || this.faqLinkElement) {
            return;
        }

        this.supportLinkElement = ref.querySelector(this.SUPPORT_LINK_SELECTOR);
        if (this.supportLinkElement) {
            this.supportLinkElement.addEventListener('click', this.handleSupportLinkClick);
        }

        this.faqLinkElement = ref.querySelector(this.FAQ_LINK_SELECTOR);
        if (this.faqLinkElement) {
            this.faqLinkElement.addEventListener('click', this.handleFAQLinkClick);
        }
    };

    public componentWillUnmount(): void {
        if (this.supportLinkElement) {
            this.supportLinkElement.removeEventListener('click', this.handleSupportLinkClick);
        }

        if (this.faqLinkElement) {
            this.faqLinkElement.removeEventListener('click', this.handleFAQLinkClick);
        }
    }

    public handleSupportLinkClick = (): void => {
        AnalyticsService.sendFlowEvent({
            action: SUPPORT_LINKS_ANALYTICS_ACTIONS.GO_SUPPORT,
            flowStepDetails: this.props.flowStepDetails || '',
            flowSubType: this.props.flowSubType || '',
            category: CATEGORY.ACTION
        });
    };

    public handleFAQLinkClick = (): void => {
        AnalyticsService.sendFlowEvent({
            action: SUPPORT_LINKS_ANALYTICS_ACTIONS.GO_FAQ,
            flowStepDetails: this.props.flowStepDetails || '',
            flowSubType: this.props.flowSubType || '',
            category: CATEGORY.ACTION
        });
    };

    public render(): JSX.Element {
        return (
            <div {...this.props} ref={this.addEventListener}>
                {this.props.children}
            </div>
        );
    }
}
